import React from "react";
import "./Works.css";
import tec1 from "../../img/tec1.png";
import tec2 from "../../img/tec2.png";
import sena from "../../img/sena.png";
import comdata from "../../img/logo_comdata.png";
import tec3 from "../../img/tec3.png";
import { themeContext } from "../../Context";
import { useContext } from "react";
import { motion } from "framer-motion";

export const Works = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="works" id="Works">
      <div className="awesome">
        <span
          style={{
            color: darkMode ? "white" : "black",
          }}
        >
          My services
        </span>
        <span>as a developer</span>
       { <span style={{ color: darkMode ? "white" : ""}}>
          Front-end development: Create the look and behavior of a web
          application's user interface using HTML, CSS, and JavaScript.
          <br />
          Back-end development: Create the underlying functionality of a web
          application
          <br />
          Cloud functions management and maintenance: Manage and maintain cloud
          functions to provide backend services.
          <br />
          Application documentation: Document the web application to facilitate
          its understanding and use by other developers.
          <br />
          Automating administrative processes: Automate repetitive tasks to
          improve efficiency.
        </span>}
        <div className="blur s-blur1" style={{ background: "#CDF9FF99" }}></div>
      </div>
      {/* right side */}
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{
            duration: 6,
            repeatType: "reverse",
            repeat: Infinity,
          }}
          className="w-mainCircle"
        >
          <div
            className="w-secCircle"
            style={{
              boxShadow: darkMode ? "0 0 15px white" : "none",
            }}
          >
            <img src={tec1} alt="" />
          </div>
          <div
            className="w-secCircle"
            style={{
              boxShadow: darkMode ? "0 0 15px white" : "none",
            }}
          >
            <img src={tec2} alt="" />
          </div>
          <div
            className="w-secCircle"
            style={{
              boxShadow: darkMode ? "0 0 15px white" : "none",
            }}
          >
            <img src={comdata} alt="" />
          </div>
          <div
            className="w-secCircle"
            style={{
              boxShadow: darkMode ? "0 0 15px white" : "none",
            }}
          >
            <img src={sena} alt="" />
          </div>
          <div
            className="w-secCircle"
            style={{
              boxShadow: darkMode ? "0 0 15px white" : "none",
            }}
          >
            <img src={tec3} alt="" />
          </div>
        </motion.div>
        {/* backgraund circle */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};
